import { Users, Heart, Shield, BookOpen } from "lucide-react";
import { motion } from "framer-motion";
import { staggerContainer, staggerItem } from "@/lib/animations";

const SocialProofBar = () => {
  const proofItems = [
    { icon: Users, value: "94,9K", label: "Seguidoras", color: "text-primary" },
    { icon: Heart, value: "Mãe de 3", label: "Mulher Real", color: "text-accent" },
    { icon: BookOpen, value: "Método", label: "Completo", color: "text-primary" },
    { icon: Shield, value: "7 Dias", label: "Garantia", color: "text-accent" },
  ];

  return (
    <section className="py-4 md:py-8 bg-gradient-to-r from-background via-card to-background border-y border-border-gold/30">
      <div className="container mx-auto px-4">
        <motion.div 
          className="grid grid-cols-2 md:flex md:flex-wrap md:justify-center items-center gap-4 md:gap-12 lg:gap-16"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
        >
          {proofItems.map((item, index) => (
            <motion.div
              key={index}
              variants={staggerItem}
              className="flex items-center gap-2.5 px-2 py-1.5 md:px-4 md:py-2 justify-center md:justify-start"
            >
              <div className={`w-9 h-9 md:w-12 md:h-12 rounded-full bg-card border border-border-gold/40 flex items-center justify-center shadow-soft ${item.color}`}>
                <item.icon className="w-4 h-4 md:w-6 md:h-6" />
              </div>
              <div className="text-left">
                <span className="block text-base md:text-2xl font-bold text-primary">
                  {item.value}
                </span>
                <span className="text-[11px] md:text-sm text-foreground/70">
                  {item.label}
                </span>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default SocialProofBar;
